export const skewedRight = {
  transform: 'skewX(-8deg)',
  '&>span': {
    display: 'inline-block',
    transform: 'skewX(8deg)'
  }

}
